<template>
    <div>
        <vue-scroll :ops="$ops">
            <div :style="{'height':(clientHeight-98)+'px'}">
                <div class="left">
                    <div class="m-portlet m-b-10">
                        <div class="m-portlet__body">
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-popover placement="right" trigger="click" v-model="favorites">
                                        <div class="m-portlet" :style="{'width':(clientWidth)/4+'px'}">
                                            <div class="m-portlet__head">
                                                <div class="m-portlet__head-caption" style="width: 100%">
                                                    <div class="m-portlet__head-title"
                                                         style="width: 100%;display: flex;">
                                                        <div style="width: 50%">
                                                            <h4>收藏列表</h4></div>
                                                        <div style="width: 40%"></div>
                                                        <div style="width: 10%">
                                                            <div>
                                                                <i class="el-icon-plus"
                                                                   @click="addCustomListDialogVisible  = true"
                                                                   style="margin-right: 20px;margin-top: 10px;font-size: large"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="m-portlet__body">
                                                <div style="overflow: auto; width: 100%;height: 300px;">
                                                    <table class="table table-striped" style="table-layout:fixed">
                                                        <thead>
                                                        <tr>
                                                            <th>名称</th>
                                                            <th>操作</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="item in customLists">
                                                            <td>{{item.name}}</td>
                                                            <td>
                                                                <el-button
                                                                        @click="showCustomList(item.id,item.name)"
                                                                        type="text"
                                                                        style="margin-right: 10px"
                                                                >展开
                                                                </el-button>
                                                                <el-button size="mini"
                                                                           @click="handleCancelCustomVisitList(item.id,item.name)"
                                                                           type="danger" icon="el-icon-delete"
                                                                           circle></el-button>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>
                                        <el-button slot="reference" type="warning" round>收藏夹</el-button>
                                    </el-popover>
                                </el-col>
                                <el-col :span="12">
                                    <el-popover placement="right" trigger="click" v-model="myFavorite">
                                        <div class="m-portlet" :style="{'width':(clientWidth)/3+'px'}">
                                            <div class="m-portlet__head">
                                                <div class="m-portlet__head-caption">
                                                    <div class="m-portlet__head-title">
                                                        <h4>我的收藏</h4>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="m-portlet__body">
                                                <div style="overflow: auto; width: 100%;height: 300px;">
                                                    <table class="table table-striped" style="table-layout:fixed">
                                                        <thead>
                                                        <tr>
                                                            <th>姓名</th>
                                                            <th v-if="powers.includes(19)">回访</th>
                                                            <th>操作</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="item in customStudents">
                                                            <td>{{item.studentName}}</td>
                                                            <td v-if="powers.includes(19)">
                                                                <el-button size="mini"
                                                                           @click="handleReturnVisitInformation(item.student_id,item.studentName)">
                                                                    查看回访
                                                                </el-button>
                                                            </td>
                                                            <td>
                                                                <el-popover placement="right" width="200"
                                                                            trigger="click">
                                                                    <ul>
                                                                        <li v-for="customList in customLists">
                                                                            <el-button type="text"
                                                                                       @click="addStudentToCustomList(customList.id,item.student_id)">
                                                                                {{customList.name}}
                                                                            </el-button>
                                                                        </li>
                                                                    </ul>
                                                                    <i class="el-icon-plus"
                                                                       @click="addCustomListDialogVisible  = true"
                                                                       style="margin-left: 20px"></i>

                                                                    <el-button slot="reference" icon="el-icon-plus"
                                                                               size="mini"
                                                                               circle></el-button>
                                                                </el-popover>
                                                                <el-button
                                                                        @click="handleCollectCancel(item.student_id)"
                                                                        type="danger"
                                                                        icon="el-icon-delete" size="mini"
                                                                        circle></el-button>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>
                                        <el-button slot="reference" type="danger" round>我的收藏</el-button>
                                    </el-popover>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <div class="m-portlet">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        筛选条件
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body">
                            <el-form>
                                <div v-if="defaultReturnVisit!==true">
                                    <el-form-item>
                                        <el-button @click="closeShowCustomList()" size="mini">展示全部</el-button>
                                    </el-form-item>
                                </div>
                                <div v-if="defaultReturnVisit===true">
                                    <el-form-item label="学期有课学生">
                                        <el-select v-model="filter.semester_id" clearable placeholder="请选择学期"
                                                   @change="handleIndexStudent()">
                                            <el-option
                                                    v-for="item in semesters"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="班主任">
                                        <el-select v-model="filter.headTeacher_id" clearable placeholder="请选择班主任"
                                                   filterable
                                                   remote
                                                   :remote-method="handleSearchHeadTeacher"
                                                   @change="handleIndexStudent()">
                                            <el-option
                                                    v-for="item in headTeachers"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="学生名字">
                                        <el-select v-model="filter.student_id" clearable placeholder="请选择学生名字"
                                                   filterable remote
                                                   :remote-method="handleSearchStudent"
                                                   @change="handleIndexStudent()">
                                            <el-option
                                                    v-for="item in haveStudents"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="是否有班主任的学生">
                                        <el-select v-model="filter.hasHeadTeacherStudent" clearable
                                                   placeholder="请选择是否有班主任的学生"
                                                   @change="handleIndexStudent()">
                                            <el-option
                                                    v-for="item in hasHeadTeacherStudents"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
<!--                                    <el-form-item label="有状况的学生">-->
<!--                                        <el-select v-model="filter.hasHappenStudent" clearable placeholder="请选择有状况的学生"-->
<!--                                                   @change="handleIndexStudent()">-->
<!--                                            <el-option-->
<!--                                                    v-for="item in hasHappenStudents"-->
<!--                                                    :key="item.value"-->
<!--                                                    :label="item.label"-->
<!--                                                    :value="item.value">-->
<!--                                            </el-option>-->
<!--                                        </el-select>-->
<!--                                    </el-form-item>-->
                                    <el-form-item label="本周是否回访的学生">
                                        <el-select v-model="filter.weekReturnStudent" clearable placeholder="请选择有状况的学生"
                                                   @change="handleIndexStudent()">
                                            <el-option
                                                    v-for="item in weekReturnStudents"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="m-portlet">
                        <div class="m-portlet__body">
                            <table class="table table-striped" v-loading="loading">
                                <thead>
                                <tr>
                                    <th>收藏</th>
                                    <th>姓名</th>
                                    <th>最近情况</th>
                                    <!--<th>学生联系方式</th>-->
                                    <th>家长姓名</th>
                                    <th>家长联系方式</th>
                                    <th>星级</th>
                                    <th>班主任</th>
                                    <th>本月回访次数</th>
                                    <th v-if="powers.includes(19)">操作</th>
                                    <th v-if="defaultReturnVisit===false">移除</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in orderStudents" :key="item.id">
                                    <td width="50">
                                        <div v-if="item.collect===0" style="color: red;font-size: x-large;"
                                             @click="handleCollect(item.id)"><i class="el-icon-star-off"></i>
                                        </div>
                                        <div v-else style="color: red;font-size: x-large;"
                                             @click="handleCollectCancel(item.id)"><i class="el-icon-star-on"></i>
                                        </div>
                                    </td>
                                    <td>
                                        <span>{{item.name}}</span>
                                    </td>
                                    <td>
                                        <span v-if="item.complaints !==0" class="rf">
                                                <el-tag class="fatherRed" type="danger">投
                                                    <div class="redSlot">{{item.complaints}}</div>
                                                </el-tag>
                                        </span>
                                        <span v-if="item.switching !==0" class="rf">
                                            <el-tag class="fatherRed" type="danger">换
                                                <div class="redSlot">{{item.switching}}</div>
                                            </el-tag>
                                        </span>
                                        <span v-if="item.truancy !==0" class="rf">
                                                <el-tag class="fatherRed" type="danger">缺
                                                    <div class="redSlot">{{item.truancy}}</div>
                                                </el-tag>
                                        </span>
                                        <span v-if="item.teacherFeedBack !==0" class="rf">
                                                <el-tag class="fatherRed" type="danger">馈
                                                    <div class="redSlot">{{item.teacherFeedBack}}</div>
                                                </el-tag>
                                        </span>
                                        <span v-if="item.absent !==0" class="rf">
                                                <el-tag class="fatherRed" type="danger">假
                                                    <div class="redSlot">{{item.absent}}</div>
                                                </el-tag>
                                        </span>
                                        <div v-if="item.truancy===0&&item.switching===0&&item.complaints===0&&item.teacherFeedBack===0&&item.absent===0">
                                            <el-tag type="success">无状况</el-tag>
                                        </div>
                                    </td>
                                    <!--<td>{{item.phone}}</td>-->
                                    <td>
                                        <div v-for="parent in item.parents" :key="parent.id">
                                            <span>{{parent.parent_identity}}： {{parent.name}}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-for="parent in item.parents" :key="parent.id">
                                            <span>手机: +86 {{parent.phone}}</span>
                                        </div>
                                    </td>
                                    <td style="padding: 15px 5px;">
                                        <el-rate v-model="item.star" :max="3"
                                                 @change="changeStar(item.id,item.star)" disabled></el-rate>
                                    </td>
                                    <td><span v-for="headTeacher in item.headTeachers" :key="headTeacher.id"> {{headTeacher.name}} </span>
                                    </td>
                                    <td>
                                        <el-tag type="danger">{{item.nowMonthReturnTimes[0]}}</el-tag>
                                        <el-tag type="success">{{item.nowMonthReturnTimes[1]}}</el-tag>
                                        <el-tag type="primary">{{item.nowMonthReturnTimes[2]}}</el-tag>
                                        <el-tag type="warning">{{item.nowMonthReturnTimes[3]}}</el-tag>
                                    </td>
                                    <td v-if="powers.includes(19)">
                                        <el-button size="mini" @click="handleReturnVisitInformation(item.id,item.name)">
                                            查看回访
                                        </el-button>
                                    </td>
                                    <td v-if="defaultReturnVisit===false">
                                        <el-button @click="deleteCustomVisitListStudent(item.id,selectedCustomList_id)"
                                                   type="danger" icon="el-icon-delete" size="mini" circle></el-button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="m-portlet__foot">
                            <!--分页-->
                            <div class="text-center m-t-10">
                                <el-pagination
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                        :current-page="currentPage"
                                        :page-sizes="[10, 20, 50, 100]"
                                        :page-size="10"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="total">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vue-scroll>
        <!--添加新的自定义列表Dialog-->
        <el-dialog title="添加新的自定义列表" :visible.sync="addCustomListDialogVisible" width="30%" :before-close="handleClose">
            <div>
                <el-input v-model="customListName" placeholder="请输入名称"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                            <el-button @click="handleClose()">取 消</el-button>
                            <el-button type="primary" @click="addCustomList()">确 定</el-button>
                        </span>
        </el-dialog>
        <!--回访详情-->
    </div>
</template>

<script>
    export default {
        name: "returnVisit-list",
        data() {
            return {
                path: '/returnVisit/list',
                RoS: 'return',
                favorites: false,
                myFavorite: false,
                loading: true,
                addCustomListDialogVisible: false,
                defaultReturnVisit: true,
                visible2: false,


                students: [],
                semesters: [],
                haveStudents: [],
                headTeachers: [],
                schools: [],

                customStudents: [],
                customLists: [],

                currentPage: 1,
                currentPageSize: 10,

                star: '',
                total: 0,
                headTeacher_student: '',
                notHeadTeacher_student: '',
                haveClass_student: '',
                noHeadTeacher_student: '',
                haveHeadTeacher_student: '',
                studentKeyName: '',
                grade: '',
                school: '',
                isHeadTeacherStudent: '',
                customListName: '',
                selectedCustomList_id: '',
                selectedCustomList_name: '',


                filter: {
                    headTeacher_id: '',
                    hasHeadTeacherStudent: '',
                    hasHappenStudent: '',
                    weekReturnStudent: '',
                    semester_id: 13,
                    student_id: '',
                    nowSemester_id: '',
                },

                hasHappenStudents: [{
                    value: '0',
                    label: '投诉'
                }, {
                    value: '1',
                    label: '换课'
                }, {
                    value: '2',
                    label: '缺席'
                }, {
                    value: '3',
                    label: '课堂反馈'
                }, {
                    value: '4',
                    label: '请假'
                }],
                hasHeadTeacherStudents: [{
                    value: '1',
                    label: '有班主任的学生'
                }, {
                    value: '0',
                    label: '没有班主任的学生'
                }],
                weekReturnStudents: [{
                    value: '0',
                    label: '本周未回访的学生'
                }, {
                    value: '1',
                    label: '本周回访的学生'
                }],

            }
        },
        mounted() {
        },
        created() {
            this.handleCreate();
            this.handleInit();
            this.handleIndexStudent();
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            right_level() {
                return this.$store.state.user.employee.right_level;
            },
            orderStudents: function () {
                return this._.orderBy(this.students, 'score', 'desc');
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            clientWidth() {
                return this.$store.state.config.clientWidth
            },
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleInit() {
                this.$wApi.send(this.path, 'init', {})
            },
            handleIndexStudent(currentPage = 1) {
                this.loading = true;
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                if (this.defaultReturnVisit === true) {
                    this.$wApi.send(this.path, 'list', {
                        'currentPage': currentPage,
                        'currentPageSize': this.currentPageSize,
                        'filter': this.filter
                    })
                } else if (this.defaultReturnVisit === false) {
                    this.$wApi.send(this.path, 'custom_list', {
                        'currentPage': currentPage,
                        'currentPageSize': this.currentPageSize,
                        'selectedCustomList_id': this.selectedCustomList_id
                    })
                }
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleIndexStudent(this.currentPage)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleIndexStudent(this.currentPage)
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.semesters = data.semesters;
                        this.headTeachers = data.headTeachers;
                        this.haveStudents = data.haveStudents;
                        if (Object.keys(data.customStudents).length > 0) {
                            this.customStudents = data.customStudents;
                        } else {
                            this.customStudents = new Object();
                        }
                        if (Object.keys(data.customLists).length > 0) {
                            this.customLists = data.customLists;
                        } else {
                            this.customLists = new Object();
                        }
                        break;
                    case 'list':
                        if (Object.keys(data.students).length > 0) {
                            this.students = data.students;
                        } else {
                            this.students = new Object();
                        }
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'custom_list':
                        if (Object.keys(data.students).length > 0) {
                            this.students = data.students;
                        } else {
                            this.students = new Object();
                        }
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'searchStudent':
                        this.haveStudents = data.searchData;
                        break;
                    case 'searchHeadTeacher':
                        this.headTeachers = data.searchData;
                        break;
                    case 'changeStar':
                        for (var key in this.students) {
                            if (key == data.student_id) {
                                this.students[key].star = data.star;
                                break;
                            }
                        }
                        break;
                    case 'create_collect':
                        for (var key1 in this.students) {
                            if (key1 == data.student_id) {
                                this.students[key1].collect = data.collect;
                                break;
                            }
                        }
                        this.$set(this.customStudents, data.customStudent.id, data.customStudent);
                        this.$message.success('收藏成功');
                        break;
                    case 'delete_collect':
                        for (var key2 in this.students) {
                            if (key2 == data.student_id) {
                                this.students[key2].collect = data.collect;
                                break;
                            }
                        }
                        this.$delete(this.customStudents, data.customReturnVisit_id);
                        this.$message.success('取消收藏成功');
                        break;
                    case 'store_customList':
                        this.$set(this.customLists, data.customList.id, data.customList);
                        this.$message.success('创建收藏夹成功');
                        break;
                    case 'delete_customList':
                        this.$delete(this.customLists, data.customList_id);
                        this.$message.success('删除收藏夹成功');
                        break;
                    case 'add_student_to_customList':
                        this.$message({
                            message: '添加' + data.studentName + "至" + data.customVisitListName + '列表成功',
                            type: 'success'
                        });
                        break;
                    case 'delete_student_to_customList':
                        if (!this.defaultReturnVisit) {
                            this.$delete(this.students, data.student_id)
                        }
                        break;
                }
            },
            showCustomList(selectedCustomList_id, selectedCustomList_name) {
                this.defaultReturnVisit = false;
                this.selectedCustomList_id = selectedCustomList_id;
                this.selectedCustomList_name = selectedCustomList_name;
                this.handleIndexStudent();
                this.favorites = false;
            },
            closeShowCustomList() {
                this.defaultReturnVisit = true;
                this.handleIndexStudent()
            },
            //删除自定义列表
            handleCancelCustomVisitList(customList_id, name) {
                this.$confirm('是否删除<' + name + '>收藏夹?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.path, 'delete_customList', {'customList_id': customList_id})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            changeStar(student_id, star) {
                this.$wApi.send(this.path, 'changeStar', {
                    'student_id': student_id,
                    'star': star,
                })
            },
            handleSearchHeadTeacher(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'headTeacherKeyName',
                    'headTeacherKeyName': query,
                })
            },
            handleSearchStudent(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'studentKeyName',
                    'studentKeyName': query,
                })
            },
            //添加收藏
            handleCollect(student_id) {
                this.$wApi.send(this.path, 'create_collect', {
                    'student_id': student_id
                })
            },
            //取消收藏
            handleCollectCancel(student_id) {
                this.$wApi.send(this.path, 'delete_collect', {
                    'student_id': student_id
                })
            },
            //添加学生进自定义列表
            addStudentToCustomList(customList_id, student_id) {
                this.$wApi.send(this.path, 'add_student_to_customList', {
                    'student_id': student_id,
                    'customList_id': customList_id
                })
            },
            handleReturnVisitInformation(student_id, name) {
                this.$store.dispatch('addView', {
                    'title': '回访' + name,
                    'path': '/returnVisitDetail/' + student_id,
                    'closable': true
                });
                this.router.push({path: '/returnVisitDetail/' + student_id})
                this.myFavorite = false;
            },
            deleteCustomVisitListStudent(student_id, customList_id) {
                this.$wApi.send(this.path, 'delete_student_to_customList', {
                    'student_id': student_id,
                    'customList_id': customList_id
                })
            },
            //新增自定义列表
            addCustomList() {
                this.$wApi.send(this.path, 'store_customList', {
                    'customListName': this.customListName
                });
                this.customListName = "";
                this.addCustomListDialogVisible = false
            },
            handleClose() {
                this.customListName = "";
                this.addCustomListDialogVisible = false
            }
        }
    }
</script>

<style scoped>

    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 230px;
    }

    .panel .card {
        min-height: 400px;
    }

    .card-title div {
        margin-top: -55px;
        margin-right: 20px
    }

    .card-title h4 {
        margin-left: 20px;
    }

    .fatherRed {
        position: relative;
    }

    .redSlot {
        width: 20px;
        height: 20px;
        line-height: 20px;
        font-size: 10px;
        color: #fff;
        text-align: center;
        background-color: #f00;
        border-radius: 50%;
        position: absolute;
        right: -9px;
        top: -9px;
    }
</style>
